import { render, staticRenderFns } from "./BaseFileInput.vue?vue&type=template&id=6deab7f5&scoped=true"
import script from "./BaseFileInput.vue?vue&type=script&lang=js"
export * from "./BaseFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deab7f5",
  null
  
)

export default component.exports